/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const MultiComments = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M4.475 9L2 11V3C2 2.86739 2.05268 2.74021 2.14645 2.64645C2.24021 2.55268 2.36739 2.5 2.5 2.5H10.5C10.6326 2.5 10.7598 2.55268 10.8536 2.64645C10.9473 2.74021 11 2.86739 11 3V8.5C11 8.63261 10.9473 8.75979 10.8536 8.85355C10.7598 8.94732 10.6326 9 10.5 9H4.475Z"
        stroke={props?.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9V11.5C5 11.6326 5.05268 11.7598 5.14645 11.8536C5.24021 11.9473 5.36739 12 5.5 12H11.525L14 14V6C14 5.86739 13.9473 5.74021 13.8536 5.64645C13.7598 5.55268 13.6326 5.5 13.5 5.5H11"
        stroke={props?.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvgIcon>
  )
}

export default MultiComments
